// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phone[data-v-bc865c20],
.phone-dialer[data-v-bc865c20] {
  height: 524px;
  width: 300px;
  background-color: var(--dialer-bgcolor);
  border-radius: 10px;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  -webkit-box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);
  box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
}
.phone .header[data-v-bc865c20],
.phone-dialer .header[data-v-bc865c20] {
  display: flex;
  justify-content: space-between;
  padding: 5px;
  height: 25px;
}
.phone .header .close-btn[data-v-bc865c20],
.phone-dialer .header .close-btn[data-v-bc865c20] {
  height: 25px;
  width: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--placeholder-color);
}
.phone .header .close-btn i[data-v-bc865c20],
.phone-dialer .header .close-btn i[data-v-bc865c20] {
  font-weight: 900;
}
.phone .header .call-quality[data-v-bc865c20],
.phone-dialer .header .call-quality[data-v-bc865c20] {
  height: 24px;
  color: var(--phone-text-color);
  margin-left: 8px;
  margin-top: 6px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
}
.phone .body[data-v-bc865c20],
.phone-dialer .body[data-v-bc865c20] {
  height: 390px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex-grow: 1;
}
.phone .body #remoteVideo[data-v-bc865c20],
.phone-dialer .body #remoteVideo[data-v-bc865c20],
.phone .body #localVideo[data-v-bc865c20],
.phone-dialer .body #localVideo[data-v-bc865c20] {
  position: absolute;
  z-index: -10;
}
.phone .body .status-n-functions[data-v-bc865c20],
.phone-dialer .body .status-n-functions[data-v-bc865c20] {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 24px;
}
.phone .body .phone-name[data-v-bc865c20],
.phone-dialer .body .phone-name[data-v-bc865c20] {
  color: var(--dialer-input-color);
  font-size: 20px;
  padding-top: 10px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.phone .body .phone-name.is-conf[data-v-bc865c20],
.phone-dialer .body .phone-name.is-conf[data-v-bc865c20] {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: center;
  white-space: initial;
}
.phone .body .phone-type-call[data-v-bc865c20],
.phone-dialer .body .phone-type-call[data-v-bc865c20] {
  display: block;
  color: var(--phone-text-color);
  font-size: 13px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
}
.phone .body .phone-status[data-v-bc865c20],
.phone-dialer .body .phone-status[data-v-bc865c20] {
  display: block;
  color: var(--phone-text-color);
  font-size: 18px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  text-align: center;
}
.phone .body .vpn-warning[data-v-bc865c20],
.phone-dialer .body .vpn-warning[data-v-bc865c20] {
  display: block;
  color: var(--phone-text-color);
  font-size: 13px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  text-align: center;
  line-height: 1.3em;
  padding-top: 4px;
  height: 40px;
}
.phone .body .phone-warning[data-v-bc865c20],
.phone-dialer .body .phone-warning[data-v-bc865c20] {
  display: block;
  color: var(--phone-text-color);
  font-size: 19px;
  padding-top: 10px;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  position: absolute;
  top: 62%;
}
.phone .body .func-buttons[data-v-bc865c20],
.phone-dialer .body .func-buttons[data-v-bc865c20] {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 4px auto 24px auto;
}
.phone .body .func-buttons.busy[data-v-bc865c20],
.phone-dialer .body .func-buttons.busy[data-v-bc865c20] {
  padding: 15px 0;
  grid-template-columns: repeat(2, 1fr);
}
.phone .body .func-buttons.onerow[data-v-bc865c20],
.phone-dialer .body .func-buttons.onerow[data-v-bc865c20] {
  margin: 4px auto 24px auto;
}
.phone .footer[data-v-bc865c20],
.phone-dialer .footer[data-v-bc865c20] {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
}
.phone .footer .back-btn[data-v-bc865c20],
.phone-dialer .footer .back-btn[data-v-bc865c20] {
  height: 45px;
  width: 45px;
  background-color: var(--placeholder-color);
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto 0;
  left: 43px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--bg-color);
  font-size: 22px;
  cursor: pointer;
}
.phone .calls-selector-audio[data-v-bc865c20],
.phone-dialer .calls-selector-audio[data-v-bc865c20] {
  top: 12px;
  left: 12px;
}
#remoteAudio[data-v-bc865c20],
#localAudio[data-v-bc865c20] {
  position: absolute;
  z-index: -10;
  height: 0;
  width: 0;
}
.phone-enter[data-v-bc865c20],
.phone-leave-to[data-v-bc865c20] {
  opacity: 0;
}
.phone-leave-to[data-v-bc865c20] {
  opacity: 1;
}
.phone-enter-active[data-v-bc865c20] {
  transition: all 0.5s linear;
}
.phone-leave-active[data-v-bc865c20] {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/phone/PhoneAudio.vue"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,YAAY;EACZ,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,uDAAuD;EACvD,oDAAoD;EACpD,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;;;;EAIE,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;EAEE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;;EAEE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;AACV;AACA;;EAEE,aAAa;EACb,qCAAqC;EACrC,0BAA0B;AAC5B;AACA;;EAEE,eAAe;EACf,qCAAqC;AACvC;AACA;;EAEE,0BAA0B;AAC5B;AACA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;AACV;AACA;;EAEE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf","sourcesContent":[".phone[data-v-bc865c20],\n.phone-dialer[data-v-bc865c20] {\n  height: 524px;\n  width: 300px;\n  background-color: var(--dialer-bgcolor);\n  border-radius: 10px;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  -webkit-box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);\n  -moz-box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);\n  box-shadow: 2px 5px 10px 0px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n}\n.phone .header[data-v-bc865c20],\n.phone-dialer .header[data-v-bc865c20] {\n  display: flex;\n  justify-content: space-between;\n  padding: 5px;\n  height: 25px;\n}\n.phone .header .close-btn[data-v-bc865c20],\n.phone-dialer .header .close-btn[data-v-bc865c20] {\n  height: 25px;\n  width: 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--placeholder-color);\n}\n.phone .header .close-btn i[data-v-bc865c20],\n.phone-dialer .header .close-btn i[data-v-bc865c20] {\n  font-weight: 900;\n}\n.phone .header .call-quality[data-v-bc865c20],\n.phone-dialer .header .call-quality[data-v-bc865c20] {\n  height: 24px;\n  color: var(--phone-text-color);\n  margin-left: 8px;\n  margin-top: 6px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n}\n.phone .body[data-v-bc865c20],\n.phone-dialer .body[data-v-bc865c20] {\n  height: 390px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  flex-grow: 1;\n}\n.phone .body #remoteVideo[data-v-bc865c20],\n.phone-dialer .body #remoteVideo[data-v-bc865c20],\n.phone .body #localVideo[data-v-bc865c20],\n.phone-dialer .body #localVideo[data-v-bc865c20] {\n  position: absolute;\n  z-index: -10;\n}\n.phone .body .status-n-functions[data-v-bc865c20],\n.phone-dialer .body .status-n-functions[data-v-bc865c20] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  line-height: 24px;\n}\n.phone .body .phone-name[data-v-bc865c20],\n.phone-dialer .body .phone-name[data-v-bc865c20] {\n  color: var(--dialer-input-color);\n  font-size: 20px;\n  padding-top: 10px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  max-width: 250px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.phone .body .phone-name.is-conf[data-v-bc865c20],\n.phone-dialer .body .phone-name.is-conf[data-v-bc865c20] {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  text-align: center;\n  white-space: initial;\n}\n.phone .body .phone-type-call[data-v-bc865c20],\n.phone-dialer .body .phone-type-call[data-v-bc865c20] {\n  display: block;\n  color: var(--phone-text-color);\n  font-size: 13px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n}\n.phone .body .phone-status[data-v-bc865c20],\n.phone-dialer .body .phone-status[data-v-bc865c20] {\n  display: block;\n  color: var(--phone-text-color);\n  font-size: 18px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  text-align: center;\n}\n.phone .body .vpn-warning[data-v-bc865c20],\n.phone-dialer .body .vpn-warning[data-v-bc865c20] {\n  display: block;\n  color: var(--phone-text-color);\n  font-size: 13px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  text-align: center;\n  line-height: 1.3em;\n  padding-top: 4px;\n  height: 40px;\n}\n.phone .body .phone-warning[data-v-bc865c20],\n.phone-dialer .body .phone-warning[data-v-bc865c20] {\n  display: block;\n  color: var(--phone-text-color);\n  font-size: 19px;\n  padding-top: 10px;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  position: absolute;\n  top: 62%;\n}\n.phone .body .func-buttons[data-v-bc865c20],\n.phone-dialer .body .func-buttons[data-v-bc865c20] {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  margin: 4px auto 24px auto;\n}\n.phone .body .func-buttons.busy[data-v-bc865c20],\n.phone-dialer .body .func-buttons.busy[data-v-bc865c20] {\n  padding: 15px 0;\n  grid-template-columns: repeat(2, 1fr);\n}\n.phone .body .func-buttons.onerow[data-v-bc865c20],\n.phone-dialer .body .func-buttons.onerow[data-v-bc865c20] {\n  margin: 4px auto 24px auto;\n}\n.phone .footer[data-v-bc865c20],\n.phone-dialer .footer[data-v-bc865c20] {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n  position: relative;\n}\n.phone .footer .back-btn[data-v-bc865c20],\n.phone-dialer .footer .back-btn[data-v-bc865c20] {\n  height: 45px;\n  width: 45px;\n  background-color: var(--placeholder-color);\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto 0;\n  left: 43px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--bg-color);\n  font-size: 22px;\n  cursor: pointer;\n}\n.phone .calls-selector-audio[data-v-bc865c20],\n.phone-dialer .calls-selector-audio[data-v-bc865c20] {\n  top: 12px;\n  left: 12px;\n}\n#remoteAudio[data-v-bc865c20],\n#localAudio[data-v-bc865c20] {\n  position: absolute;\n  z-index: -10;\n  height: 0;\n  width: 0;\n}\n.phone-enter[data-v-bc865c20],\n.phone-leave-to[data-v-bc865c20] {\n  opacity: 0;\n}\n.phone-leave-to[data-v-bc865c20] {\n  opacity: 1;\n}\n.phone-enter-active[data-v-bc865c20] {\n  transition: all 0.5s linear;\n}\n.phone-leave-active[data-v-bc865c20] {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
